<h1>Setup Project "{{ projectName }}"</h1>
<div>
  <mat-tab-group [selectedIndex]="activeTabIndex" (selectedIndexChange)="setUrlFragment($event)">
    <mat-tab label="Project dossier files">
      <ng-template matTabContent>
        <div class="container">
          <h3>Project integration settings:</h3>
          <div class="project-integration-settings">
            <div class="integration-row">
              <span class="label">Integration enabled</span>
              <span class="value">
                <span class="value-pill" [ngClass]="(isIntegrationEnabled$ | async) ? 'on' : 'off'">
                  <mat-icon [fontIcon]="(isIntegrationEnabled$ | async) ? 'check' : 'close'"></mat-icon>
                </span>
              </span>
            </div>
            <div class="integration-row">
              <span class="label">Mute publishing to MIPS</span>
              <span class="value">
                <span class="value-pill" [ngClass]="(isMipsPublishingMuted$ | async) ? 'on' : 'off'">
                  <mat-icon [fontIcon]="(isMipsPublishingMuted$ | async) ? 'check' : 'close'"></mat-icon>
                </span>
              </span>
            </div>
            <div class="integration-row">
              <span class="label">Last integration attempt</span>
              <span class="value">{{ (lastIntegrationAttempt$ | async) || 'Never' }}</span>
            </div>
            <div class="integration-row">
              <span class="label">Last successful integration</span>
              <span class="value">{{ (lastIntegrationSuccess$ | async) || 'Never' }}</span>
            </div>
          </div>

          <h3>Project Handover Images</h3>
          <div class="project-images">
            <div class="upload-container">
              <h3>Customer Logo:</h3>
              <app-file-uploader
                [height]="'180px'"
                [processingImage]="inProgressCustomerLogo"
                [image]="customerLogo"
                (fileUpload)="customerLogoUpload($event)"
                (fileDelete)="customerLogoDelete()"
              ></app-file-uploader>
            </div>

            <div class="upload-container handover-image-container">
              <h3>Handover Image:</h3>
              <app-file-uploader
                [height]="'480px'"
                [processingImage]="inProgressHandoverImage"
                [image]="handoverImage"
                (fileUpload)="handoverImageUpload($event)"
                (fileDelete)="handoverImageDelete()"
              ></app-file-uploader>
            </div>
          </div>
          <div>
            <button mat-button (click)="openDataDialog()">Upload Check Status Item Values</button>
          </div>
        </div>
      </ng-template>
    </mat-tab>
    <mat-tab label="Project display configuration">
      <ng-template matTabContent>
        <div class="container">
          <h3>Project Display settings</h3>
          <div>
            <app-project-config></app-project-config>
          </div>
        </div>
      </ng-template>
    </mat-tab>
    <mat-tab label="Dossier template setup">
      <ng-template matTabContent>
        <div class="container">
          <h3>Project dossier template</h3>
          @if (handoverTemplate) {
            <div>
              <app-project-template [handoverTemplate]="handoverTemplate"></app-project-template>
            </div>
          }
        </div>
      </ng-template>
    </mat-tab>
    <mat-tab label="Signature setup">
      <ng-template matTabContent>
        <div class="container signature-setup-container">
          <div class="signature-setup-header">
            <h3>Signature Matrix Template</h3>
            @if (userAccess.isProjectAdmin$ | async) {
              <button
                pButton
                class="copy-signature-setup-action"
                type="button"
                icon="pi pi-copy"
                label="Copy signature setup"
                [disabled]="hasSignatureMatrixTemplates"
                (click)="openSignatureSetupCopyDialog()"
              ></button>
            }
          </div>
          @if (hasSignatureMatrixTemplates) {
            <p class="copy-signature-setup-unavailable" role="status">
              Copying is unavailable because this project already has signature matrix templates.
            </p>
          }
          <div>
            <app-signature-matrix-template></app-signature-matrix-template>
          </div>
        </div>
      </ng-template>
    </mat-tab>
    <mat-tab label="User admin">
      <ng-template matTabContent>
        <div class="container">
          <h3>User admin</h3>
          @if (handoverTemplate) {
            <div>
              <app-user-admin></app-user-admin>
            </div>
          }
        </div>
      </ng-template>
    </mat-tab>
    <mat-tab label="Assignment roles">
      <ng-template matTabContent>
        <div class="container">
          <h3>Assignment roles</h3>
          <app-assignment-role></app-assignment-role>
        </div>
      </ng-template>
    </mat-tab>
    <mat-tab label="Metadata editor">
      <ng-template matTabContent>
        <div class="container">
          <h3>Check sheet admin</h3>
          <app-metadata-editor></app-metadata-editor>
        </div>
      </ng-template>
    </mat-tab>
    <!-- <mat-tab label="Monitoring">
      <ng-template matTabContent>
        <div class="container">
          <h3>Check sheet admin</h3>
          <app-monitoring></app-monitoring>
        </div>
      </ng-template>

    </mat-tab>-->
  </mat-tab-group>
</div>
